import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'unit', method: 'POST', body: body, token: token })
}
